import { render, staticRenderFns } from "./DiceExampleSlide.vue?vue&type=template&id=59ae3df3"
import script from "./DiceExampleSlide.vue?vue&type=script&lang=js"
export * from "./DiceExampleSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports